import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import ServiceFinderModal from './ServiceFinderModal';

interface ServiceFinderContextValue {
  openFinder: () => void;
}

const ServiceFinderContext = createContext<ServiceFinderContextValue>({ openFinder: () => {} });

export function useServiceFinder() {
  return useContext(ServiceFinderContext);
}

export function ServiceFinderProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  const openFinder = useCallback(() => setOpen(true), []);
  const closeFinder = useCallback(() => setOpen(false), []);

  return (
    <ServiceFinderContext.Provider value={{ openFinder }}>
      {children}
      {open && <ServiceFinderModal onClose={closeFinder} />}
    </ServiceFinderContext.Provider>
  );
}
